import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../../session/useFetchWithAuth'
import { adminDistrictUrl } from '../../utils/districtUrls'

const API_URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface AdminDistrict {
  id: string
  name: string
  city: string
}

export const useAdminDistricts = () => {
  const fetchWithAuth = useFetchWithAuth()

  const getDistricts: QueryFunction<AdminDistrict[]> = async () => {
    try {
      const responseData = await fetchWithAuth(`${API_URL}/admin/districts`, {
        method: 'GET',
      })
      return responseData
    } catch (error) {
      console.error('Error fetching admin districts:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['adminDistricts'] as const,
    queryFn: getDistricts,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useAdminDistrict = (name?: string, city?: string) => {
  const fetchWithAuth = useFetchWithAuth()

  const getDistrict: QueryFunction<AdminDistrict> = async () => {
    if (!name || !city) {
      throw new Error('District name and city are required')
    }

    try {
      const responseData = await fetchWithAuth(
        `${API_URL}${adminDistrictUrl({ name, city })}`,
        {
          method: 'GET',
        }
      )
      return responseData
    } catch (error) {
      console.error('Error fetching admin district:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['adminDistrict', name, city] as const,
    queryFn: getDistrict,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: !!name && name.length > 0 && !!city && city.length > 0,
  })
}
